<ng-container *ngIf="(lead$ | async) as lead">

  <sidenav-content-header [title]="'Lead '+lead.id" (close)="onCloseClick()">
    <span buttonInfo><label>Esito</label>
      {{  'enums.qualificationStatus.' + lead.qualificationStatus | translate}}
    </span>

    <span buttonInfo style="cursor: pointer;" title="visualizza info ricevute"
      (click)="canViewFirstAcquisitionData && onShowLeadReceivedInformation()">
      <label>Prima acquisizione</label>
      {{lead?.created | formatDateWithTimezone | async}}

      <mat-icon *ngIf="canViewFirstAcquisitionData">open_in_new</mat-icon>
    </span>

    <span buttonInfo><label>ultima modifica</label>
      {{ lead.updated | formatDateWithTimezone | async}}</span>
  </sidenav-content-header>

  <mat-tab-group *ngIf="showTabs; else oneTabsContent">

    <mat-tab label="Dettagli" *ngIf="shouldShowDetails">
      <lead-info-form [lead]="lead" [readOnly]="!(lead | isLeadEditable)"
        [showFooterResume]="showDetailsFooterResume"
        [showAutoAssignButton]="[lead, (user$ | async)] | showAutoAssignButton"
        (dirty)="askConfirmationOnClose = $event" (cancel)="close()" (refresh)="onRefreshLeadInfo()"
        (leadModified)="onLeadModified()">
      </lead-info-form>
    </mat-tab>

    <mat-tab label="Stati"
      *ngIf="shouldShowHistoryTransitions && (user$ | async | hasPermission:userPermission.SearchLeadHistory)">
      <sidenav-content-lead-info-state-history [transitions]="lead.statusHistory">
      </sidenav-content-lead-info-state-history>
    </mat-tab>

    <mat-tab label="Audit"
      *ngIf="shouldShowHistoryAudits && (user$ | async | hasPermission:userPermission.SearchLeadAudit)">
      <sidenav-content-lead-info-audits [leadId]="lead.id"></sidenav-content-lead-info-audits>
    </mat-tab>

  </mat-tab-group>

  <ng-template #oneTabsContent>

    <lead-info-form *ngIf="shouldShowDetails" [lead]="lead" [showFooterResume]="showDetailsFooterResume"
      (leadModified)="askConfirmationOnClose =false; close()" [readOnly]="!(lead | isLeadEditable)"
      (dirty)="askConfirmationOnClose = $event" (cancel)="close()">
    </lead-info-form>

    <sidenav-content-lead-info-state-history
      *ngIf="shouldShowHistoryTransitions && (user$ | async | hasPermission:userPermission.SearchLeadHistory)"
      [transitions]="lead.statusHistory">
    </sidenav-content-lead-info-state-history>

    <sidenav-content-lead-info-audits
      *ngIf="shouldShowHistoryAudits && (user$ | async | hasPermission:userPermission.SearchLeadAudit)"
      [leadId]="lead.id">
    </sidenav-content-lead-info-audits>

  </ng-template>

</ng-container>
